import { createBrowserHistory } from 'history';

/**
 * 全局共享的路由 history 单例。
 * 供 React 之外的模块（如 axios 拦截器）做 SPA 内跳转使用，
 * 避免 window.open('_self') 整页重载带来的二次 bootstrap 开销。
 * 必须与 router.tsx 的 <Router history={appHistory}> 复用同一个实例。
 */
export const appHistory = createBrowserHistory();
